import { render, staticRenderFns } from "./StorageMakePrice.vue?vue&type=template&id=2c7414b8"
import script from "./StorageMakePrice.vue?vue&type=script&lang=js"
export * from "./StorageMakePrice.vue?vue&type=script&lang=js"
import style0 from "./StorageMakePrice.vue?vue&type=style&index=0&id=2c7414b8&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports